import { z } from "zod";

import { ApiService } from "./ApiService";
import { GrantedPermissions } from "./PermissionsService";

const SignInResponse = z.object({
    token: z.string(),
    permissions: GrantedPermissions,
});
type SignInResponse = z.infer<typeof SignInResponse>;

class AuthenticationService extends ApiService {
    async signIn(email: string, password: string): Promise<SignInResponse> {
        const response = await this.post<SignInResponse>("sign_in", { email, password });
        return this.attemptParse(SignInResponse, response);
    }

    async getPermissions(): Promise<GrantedPermissions> {
        const response = await this.get("my-permissions");
        return this.attemptParse(GrantedPermissions, response);
    }
}

export default new AuthenticationService();
